import { useState, useEffect } from "react";

function AddToCartButton({
  loading,
  Skeleton,
  handleAddToCart,
  wishlistLoading, // pass from parent
  quantity,
  toggleWishlist,
  selectedSize,
  Heart,
}) {
 const [isWishlisted, setIsWishlisted] = useState(false);
  // Sync local state when selectedSize changes
  useEffect(() => {
    setIsWishlisted(selectedSize?.is_wishlisted === true || selectedSize?.is_wishlisted === 1);
  }, [selectedSize]);

  const handleWishlistClick = async (e) => {
    e.stopPropagation();
    if (!selectedSize || wishlistLoading?.[selectedSize.id]) return;

    // Call parent logic
    await toggleWishlist(e, selectedSize);

    // After request, sync UI with updated state
    setIsWishlisted(selectedSize?.is_wishlisted === true || selectedSize?.is_wishlisted === 1);
  };
  
  
  return (
    <div className="add-cart-sticky-wrapper">
      <div className="add-cart-section">
        {loading ? (
          <Skeleton
            height={45}
            width={180}
            borderRadius={8}
            style={{ marginRight: 20 }}
          />
        ) : (
          <>
            <button
              type="button"
              className="add-to-cart-btn_qucick"
              onClick={handleAddToCart}
              disabled={quantity === 0 || selectedSize?.stock <= 0}
            >
              {selectedSize?.stock <= 0 || quantity === 0
                ? "Out of Stock"
                : "ADD TO CART"}
            </button>

           <div
              className={`wst_box_quick pointer-crusser ${
                wishlistLoading?.[selectedSize?.id] ? "disabled" : ""
              }`}
              onClick={handleWishlistClick}
            >
              {wishlistLoading?.[selectedSize?.id] ? (
                <span className="wishlist-loading">...</span> // optional loading placeholder
              ) : isWishlisted ? (
                <Heart size={27} color="#FF0000" fill="#FF0000" />
              ) : (
                <Heart size={27} color="#000" fill="none" />
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

export default AddToCartButton;